import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames'

class UsersPickerRowPlaceholder extends Component {
  static propTypes = {
    className: PropTypes.string,
  }

  render() {
    return (
      <div
        className={classNames([
          this.props.className,
          'flexbox flexbox-row flexbox-align-center padding-normal',
        ])}
      >
        <div
          className="background-shade-50 radius-largest"
          style={{ height: 24, width: 24 }}
        />
        <div className="flexbox margin-horizontal-normal">
          <div className="shade-40">@</div>
          <div
            className="background-shade-50 radius-normal "
            style={{ height: 16, width: 45 }}
          />
        </div>
        <div
          className="background-shade-50 radius-normal"
          style={{ height: 16, width: 90 }}
        />
      </div>
    )
  }
}

export default UsersPickerRowPlaceholder
